// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l_jtV","badges":"styles_badges__1XtMz"};